var map = {
	"./belgie-Dinsdag.png": 3760,
	"./belgie-Donderdag.png": 204,
	"./belgie-Maandag.png": 7841,
	"./belgie-Vrijdag.png": 1527,
	"./belgie-Woensdag.png": 4464,
	"./belgie-Zaterdag.png": 4618,
	"./belgie-Zondag.png": 9285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1755;